export default __webpack_public_path__ + "static/media/preppysport_logo.e22d3d43.png";